"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = () => {
    return {
        schemaType: "object",
        properties: [
            {
                title: "検索置換対象",
                propertyName: `target`,
                schema: {
                    schemaType: "radio",
                    options: [
                        { label: "翻訳文", value: "translated" },
                        { label: "翻訳前テキスト", value: "original" },
                    ],
                },
            },
            {
                title: "検索文字",
                propertyName: "searchValue",
                schema: {
                    schemaType: "text",
                    required: true,
                },
            },
            {
                title: "置換文字",
                propertyName: "replaceValue",
                schema: {
                    schemaType: "text",
                    required: true,
                },
            },
        ],
    };
};
